import { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ModelOfContractBiddingItem, ModelOfItemUnit } from 'src/database';
import { useData } from 'src/contexts/data';

import api from 'src/services/api';

const selectedItemEmptyObj = {
	CONTRATOORGAOUNIDADELICITACAO: '',
	DESCRICAO: '',
	MARCA: '',
	QUANTIDADEREAL: 0,
	QUANTIDADE: 0,
	UNIDADE: '',
	VALOR: 0,
};

export const useFormCreateContractItem = () => {
	const { selectedContractBidding } = useData();
	const [formDialog, setFormDialog] = useState(false);
	const [editDialog, setEditDialog] = useState(false);
	const [loading, setLoading] = useState(false);
	const [unitsData, setUnitsData] = useState<ModelOfItemUnit[]>([]);
	const [selectedItem, setSelectedItem] = useState<ModelOfContractBiddingItem>(selectedItemEmptyObj);

	const validationSchema = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo obrigatório'),
		UNIDADE: Yup.string().required('* Campo obrigatório'),
		MARCA: Yup.string().required('* Campo obrigatório'),
		QUANTIDADEREAL: Yup.number().typeError('O valor informado deve ser um número.').required('* Campo obrigatório'),
		QUANTIDADE: Yup.number().typeError('O valor informado deve ser um número.').required('* Campo obrigatório'),
		VALOR: Yup.number().typeError('O valor informado deve ser um número.').required('* Campo obrigatório'),
	});

	const toast: any = useRef();

	useEffect(() => {
		const getUnits = () => {
			api.get('item-units')
				.then((response) => {
					setUnitsData(response.data);
				})
				.catch((err) => {
					console.log(err);
				});
		};

		getUnits();
	}, []);

	const openDialogForm = () => {
		setFormDialog(true);
	};

	const openDialogEdit = (item: ModelOfContractBiddingItem) => {
		setEditDialog(true);
		setSelectedItem(item);
	};

	const closeDialog = () => {
		setFormDialog(false);
		setEditDialog(false);
		setSelectedItem(selectedItemEmptyObj);
	};

	const saveContractItems = (contractItem: ModelOfContractBiddingItem) => {
		setLoading(true);
		const newContractItem = {
			...contractItem,
			QUANTIDADEREAL: contractItem.QUANTIDADE,
			CONTRATOORGAOUNIDADELICITACAO: selectedContractBidding?.ID,
		};

		if (selectedItem?.ID) {
			api.put(`bidding-contract-items/${selectedItem?.ID}`, newContractItem)
				.then((response) => {
					setEditDialog(false);
					setLoading(false);
					toast.current.show({
						severity: 'success',
						summary: 'Edição realizada',
						detail: 'O item foi cadastrado com sucesso!',
						life: 5000,
					});
				})
				.catch((err) => {
					console.log(err);
					setLoading(false);
					toast.current.show({
						severity: 'error',
						summary: 'Edição não realizada',
						detail: 'Falha ao realizar operação!',
						life: 5000,
					});
				});
		} else {
			api.post('bidding-contract-items', newContractItem)
				.then((response) => {
					setFormDialog(false);
					setLoading(false);
					toast.current.show({
						severity: 'success',
						summary: 'Cadastro realizado',
						detail: 'O item foi cadastrado com sucesso!',
						life: 5000,
					});
				})
				.catch((err) => {
					console.log(err);
					setLoading(false);
					toast.current.show({
						severity: 'error',
						summary: 'Cadastro não realizado',
						detail: 'Falha ao realizar operação!',
						life: 5000,
					});
				});
		}
	};

	const formik = useFormik<ModelOfContractBiddingItem>({
		initialValues: {
			CONTRATOORGAOUNIDADELICITACAO: '',
			DESCRICAO: '',
			MARCA: '',
			QUANTIDADEREAL: 0,
			QUANTIDADE: 0,
			UNIDADE: '',
			VALOR: 0,
		},
		onSubmit: (values) => saveContractItems(values),
		validationSchema,
	});

	return {
		getFormContractItem: {
			formik,
			formDialog,
			editDialog,
			loading,
			unitsData,
			selectedItem,
			toast,
		},
		handleFormContractItem: {
			openDialogForm,
			openDialogEdit,
			closeDialog,
		},
	};
};
